import AppointmentsTVModePage from '@/modules/appointments/AppointmentsTVModePage';
import { UserRole } from '@nova/core';
import AppointmentsSearchPage from '@/modules/appointments/components/AppointmentsSearchPage';
import AppointmentsPage from '@/modules/appointments/AppointmentsPage.vue';
import AppointmentsPageMobile from '@/modules/appointments/mobile/AppointmentsPageMobile.vue';
import { getComponentForDevice } from '@/routes';
import i18n from '@/plugins/i18n.js';

export default [
  {
    path: '/appointments',
    name: 'appointments',
    component: getComponentForDevice(AppointmentsPage, AppointmentsPageMobile),
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.appointments'),
      requiresAuth: true,
      customHeader: true,
      pageClass: 'app-appointments',
      maxRole: UserRole.OWNER,
      allowMobile: true
    }
  },
  {
    path: '/search/appointments',
    name: 'appointments.search',
    component: AppointmentsSearchPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.searchAppointments'),
      requiresAuth: true,
      pageClass: 'app-appointments-search',
      maxRole: UserRole.OWNER
    }
  },
  {
    path: '/appointments/tv',
    name: 'appointmentsTV',
    component: AppointmentsTVModePage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.appointmentsTvMode'),
      requiresAuth: true,
      customHeader: true,
      pageClass: 'app-appointments-tv',
      hideSidebar: true,
      fullScreen: true,
      maxRole: UserRole.OWNER
    }
  }
];
